<template>
  <div>
    <transition name="modal">
      <confirmation-modal
        v-if="showConfirmationModal"
        :message="'¿Estás seguro que deseas cambiar este valor?'"
        @close="showConfirmationModal = false"
        @confirm="update"
      ></confirmation-modal>
    </transition>

    <div class="flex flex-col">
      <div v-if="!showForm" class="mt-2">
        <button class="secondary-button" @click.prevent="showForm = true">
          Cambiar
        </button>
      </div>

      <div v-else class="flex flex-col space-y-2 mt-2">
        <input id="discount" type="number" step="any" v-model="quantity" class="" />

        <button class="cancel-button block" @click.prevent="showForm = false">
          Cancelar
        </button>

        <primary-button
          class="mx-0"
          :loading="loadingUpdate"
          type="submit"
          @click.prevent="showConfirmationModal = true"
          >Guardar</primary-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import ConfirmationModal from "../ui/ConfirmationModal";
import api from "@/api";
export default {
  name: "Discount",

  components: {
    ConfirmationModal,
  },

  data() {
    return {
      showForm: false,
      quantity: null,
      showConfirmationModal: false,
      loadingUpdate: false,
    };
  },

  props: {
    subcategory: Object,
  },

  created() {
    this.quantity = this.subcategory.totalQuantity;
  },

  methods: {
    async update() {
      this.showConfirmationModal = false;
      this.loadingUpdate = true;

      try {
        const response = await api.inventories.update(
          this.subcategory.inventoryId,
          {
            quantity: this.quantity,
          }
        );
        this.$store.dispatch("successSnack", response.message);
        this.$emit("quantityUpdated");
      } catch (error) {
        this.$store.dispatch("errorSnack", error?.response?.data?.message);
      }

      this.loadingUpdate = false;
    },
  },
};
</script>